import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import AutoResizeTextarea from "components/common/AutoResizeTextarea";
import { useDialog } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import { SCREEN } from "helper/roleChecker/Screens";
import { handleRequestStart } from "modules/DeclareLeave/redux/handleRequest";
import { selectHandleRequestData } from "modules/DeclareLeave/redux/selector";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { isOpenDialogSelector } from "redux-store/static/redux/selector";
import pxToRem from "theme/base/pxToRem";

export const PopupConfirm = () => {
  const { type } = useParams();
  const dispatch = useDispatch();
  const { isApprove, id, warning } = useSelector(selectHandleRequestData);

  const open = useSelector(isOpenDialogSelector(DIALOG.APPROVE_REQUEST_POPUP));
  const approveDialog = useDialog(DIALOG.APPROVE_REQUEST_POPUP);
  const [note, setNote] = useState("");

  const handleOnChange = (e: string) => {
    setNote(e);
  };

  const handleSubmit = useCallback(() => {
    dispatch(
      handleRequestStart({
        tab: type,
        id,
        refuseReason: note,
        status: isApprove ? "APPROVE" : "REFUSE",
        screenCode: SCREEN.IP_017,
      })
    );
    setNote("");
  }, [dispatch, id, isApprove, note, type]);

  const handleOnClose = () => {
    setNote("");
    approveDialog.close();
  };

  return (
    <Dialog open={open} onClose={handleOnClose} maxWidth="lg">
      <DialogTitle textAlign={"center"}>
        {isApprove ? "Xác nhận phê duyệt" : "Xác nhận từ chối"}
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: pxToRem(16) }}>
        {warning && (
          <Typography
            fontSize={14}
            color={"error"}
            sx={{ maxWidth: pxToRem(380) }}
          >
            {warning}
          </Typography>
        )}

        <Box display={"flex"} gap={0.5}>
          <Typography fontSize={14}>
            {isApprove ? "Ghi chú" : "Nhập lý do từ chối"}{" "}
          </Typography>
          <Typography
            fontSize={14}
            sx={(theme) => ({ color: theme.palette.text.textSecondary })}
          >
            {`(${isApprove ? "Không bắt" : "Bắt"}  buộc)`}
          </Typography>
        </Box>
        <AutoResizeTextarea
          placeholder="Nhập ghi chú của bạn"
          onChange={handleOnChange}
          sx={{ width: pxToRem(380), paddingTop: 1, paddingBottom: 1 }}
          value={note}
        />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ padding: pxToRem(16) }}>
        <Button
          onClick={handleOnClose}
          fullWidth
          variant="blur"
          sx={(theme) => ({
            background: theme.palette.background.bgSecondary,
            color: theme.palette.text.textPrimary,
          })}
        >
          Đóng
        </Button>
        <Button
          onClick={() => {
            handleSubmit();
            approveDialog.close();
          }}
          fullWidth
          disabled={!note.trim() && !isApprove}
          color={isApprove ? "success" : "error"}
          sx={(theme) => ({
            color: theme.palette.text.textWhite,
          })}
        >
          {isApprove ? "Phê duyệt" : "Từ chối"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
